import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FormItem, useFiltersLabel, FiltersNameEnum, FilterDrawerType } from '@blocs.filter';
import { DateRange } from '../../../FilterCollection';
import { FiltersCategoryNameEnum } from '../../shared/types';

interface Props {
  type: FilterDrawerType;
}

const WorkPermitExpirationDatesCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.workPermitExpirationDates
  );

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <DateRange
          dateRangeName={FiltersNameEnum.workPermitExpiration}
          dateRangeMinName={FiltersNameEnum.min}
          dateRangeMaxName={FiltersNameEnum.max}
          label={filtersLabelOfAudience[FiltersNameEnum.workPermitExpiration]}
        />
      </FormItem>
    )
  );
};

export default WorkPermitExpirationDatesCategory;
